<ul class="total-questions">
  <li *ngFor="let item of values" class="question-ball " [title]="'state: ' + item.state + ' - open' + (item.open ? 1 :0)"
    [ngClass]="{
        current: item.id === active
        , done: item.open === false
        , good: item.state === 'good'
        , wrong: item.state ==='wrong'}"    ></li>
</ul>
